<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

const encryptedText = this.CryptoJS.AES.encrypt("Hi There!",  'secret key 123').toString()
const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto)=>{
        return this.CryptoJS.AES.encrypt(texto,  'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto)=>{
        return this.CryptoJS.AES.decrypt(texto,'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf,num_cand)=>{

        let candidato = {CPF:cpf,NUMEROINSC:num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-','')*7919;
        codigo_meio=codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0,5))*parseInt(candidato.NUMEROINSC.replace('-',''))*13 + '_'
        + String.fromCharCode(65 + parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[1]))
        + String.fromCharCode(parseInt(codigo_meio[4]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[7]%2===0? 97 : 67)+ parseInt(codigo_meio[7]))
        + '-'
        + String.fromCharCode(parseInt(codigo_meio[0]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))
        + String.fromCharCode(parseInt(codigo_meio[5]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[8]))
        + '_'
        + String.fromCharCode(parseInt(codigo_meio[2]%2===0? 97 : 67)+ parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[6]))
        + String.fromCharCode(parseInt(codigo_meio[6]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))

        return codigo_arquivo+'.pdf';
      }


      let cands = [
  {
    "num_cand": "U2FsdGVkX19urJAwKdtryYsfEUEsw0/tRpskC74Y348=",
    "cpf": "U2FsdGVkX1+99P284zYcF/S0H8dz3MdSm8j/8E5jMcw="
  },
  {
    "num_cand": "U2FsdGVkX18nKZ10dKRmhlLJxAcFscCgU0+jxcwOF+Q=",
    "cpf": "U2FsdGVkX1/PNg8URwYr1rvc4SwTIsRpKjeihHfSdB8="
  },
  {
    "num_cand": "U2FsdGVkX18IczhwzhYOXYOz9YDrX/iG0JkxlfpanOw=",
    "cpf": "U2FsdGVkX18Sigmv1mrF7yVa7N6uOW0Gnz7B+zS7DcI="
  },
  {
    "num_cand": "U2FsdGVkX19VSgxyvJMmeI5efThyqfCgRRyl6dWAalE=",
    "cpf": "U2FsdGVkX18wfdz5CQ2mBgS7HgSTDJlj8C9fZdoGHxY="
  },
  {
    "num_cand": "U2FsdGVkX1/68v0ykdOo+wLa7vXvPt2tVGn9PakNZEQ=",
    "cpf": "U2FsdGVkX1/PtHdY+LLsMmKiJDtoYEhe9Rp71agETB4="
  },
  {
    "num_cand": "U2FsdGVkX18aGhY20usu3TT0q3YiGjni2NSYh9uW4qw=",
    "cpf": "U2FsdGVkX1+hHGW17OUTkEJ6gAyVGVQVG+AiD/O7MTE="
  },
  {
    "num_cand": "U2FsdGVkX18itEDF1fnlo7Z7qkNA/iY7FA8/W7guHgg=",
    "cpf": "U2FsdGVkX1/uKaYWju4PJrNJ5F5MVqXBQxnG2GmMxHg="
  },
  {
    "num_cand": "U2FsdGVkX1+Ym79YQjzk+81A5wAHcZsj6aDTJBc35qA=",
    "cpf": "U2FsdGVkX1/P36AkClQbElnPK084cSkDBrQFAvcOSNk="
  },
  {
    "num_cand": "U2FsdGVkX192WFkFatsYL2yxgmnjm2EFVD9VByMfMVU=",
    "cpf": "U2FsdGVkX18HEK7qxNjtqN7smCPCADq9tHpIjnycxCc="
  },
  {
    "num_cand": "U2FsdGVkX190k96GfOgHw23ID5dZXFhWD7utSOwNJ2o=",
    "cpf": "U2FsdGVkX1/iyKa1sjRunVWpaxAqQZx295+ErjabwcE="
  },
  {
    "num_cand": "U2FsdGVkX1+p2vkYinsMWnjwvQBNRMiZ0Bcos32ix28=",
    "cpf": "U2FsdGVkX18PpZvRSfep7GTMv8uBxsQkmX05KPxQ1SQ="
  },
  {
    "num_cand": "U2FsdGVkX19K8g3IS4yAKONfVIRMM0T3luyUUTXdSnc=",
    "cpf": "U2FsdGVkX1+2lXmFBn4Wmrd7PdLLLBCr/iJm+uOpTpw="
  },
  {
    "num_cand": "U2FsdGVkX1+u3igNLEUkp64+62aMNJ0wrJV2tGegudg=",
    "cpf": "U2FsdGVkX1/IG+7mbX8/7DbpUsS5CyziqCae9XmHEs4="
  },
  {
    "num_cand": "U2FsdGVkX1/+57cfoQ3sF5kQKP5bqKLZ0RJU13Syzb4=",
    "cpf": "U2FsdGVkX1+/rzqy52lFBDl3Z4PNohlCULmPFPaEbLE="
  },
  {
    "num_cand": "U2FsdGVkX1/YD9uwPzCJP7Abpp9nBUfKcIDAOBhEd3o=",
    "cpf": "U2FsdGVkX1+bKp2u4K4bTprI2XDfqgXvF5a1uc1MieY="
  },
  {
    "num_cand": "U2FsdGVkX1+r8AIcRHG7652X7jkKndcTo5w8RiQh+Ak=",
    "cpf": "U2FsdGVkX19RdUwtM2/k8UPJ4/YPt77Nq/cWmwId4Qc="
  },
  {
    "num_cand": "U2FsdGVkX196IJ3Uk6rTvtTiwZ7FY7Uzo7NJUcJwCHY=",
    "cpf": "U2FsdGVkX1+JvkU4lObYwnwMLNEUuKpG463HVdCdEZM="
  },
  {
    "num_cand": "U2FsdGVkX1/OVlUDwT4aLkVZq/8f5A9H/R/1xbAMrCw=",
    "cpf": "U2FsdGVkX1/0QXyX6v4aaRYdVGaeGnNzIhAfSE5367k="
  },
  {
    "num_cand": "U2FsdGVkX18y9uisaCdoj5801Hv+3zEF/idDuTDwB1U=",
    "cpf": "U2FsdGVkX1/+PuozqFzFneqH/dqDLlRruDzkD4F+cRc="
  },
  {
    "num_cand": "U2FsdGVkX19AOrn44e9pz7D28C405eO2gshkGsoGU5g=",
    "cpf": "U2FsdGVkX1+0ygzyGtKnAGTqQ1p6yBMg7S0DzQcr96k="
  },
  {
    "num_cand": "U2FsdGVkX19G4rql57chqYqVmh3+qwmcZNn2eIPfE2s=",
    "cpf": "U2FsdGVkX198idR3biu25san5zRJG4EG8JXuOCcZ4Bs="
  },
  {
    "num_cand": "U2FsdGVkX1+hOHYIs/zZ/+ap6Asd7yXIidTEUmigK/8=",
    "cpf": "U2FsdGVkX19ousLIDwd63Zl02yOIirxxb60J6UigwJQ="
  },
  {
    "num_cand": "U2FsdGVkX18LO4kjLU8AP5JNSsBU6hDALTzCLIgw8nk=",
    "cpf": "U2FsdGVkX1/2qOztsi9Zkd6jv7v+qiWmhLaN9f1F5Fw="
  },
  {
    "num_cand": "U2FsdGVkX1+Nue61DaLt8fJJQD2DPnyqqbsDaZdwVoo=",
    "cpf": "U2FsdGVkX18es/1aIYU63+y1WybgxhU5iUWXVOTDOLk="
  },
  {
    "num_cand": "U2FsdGVkX1+VTEK8r73jrP7Gr1YP5FFkPbbb3szAJjE=",
    "cpf": "U2FsdGVkX18YBfO7mRccWpOo26/s9BDYgCNcJpV5PH8="
  },
  {
    "num_cand": "U2FsdGVkX198mEpbZfHrvZGEW6EV5rR/Dgjm5dTh+kg=",
    "cpf": "U2FsdGVkX19WzJfY8MMB+f6HrS2fxduSd4n4/UqxuD4="
  },
  {
    "num_cand": "U2FsdGVkX1/U7h3290E6V4TPdOBNscoyGEuTkwjqAkI=",
    "cpf": "U2FsdGVkX19Jx/CCE2LxhJTjNqI3nFWlk/j1tffE7YA="
  },
  {
    "num_cand": "U2FsdGVkX18FkpcWq1M9On7PABhx1ENZ1oE29MC0NSs=",
    "cpf": "U2FsdGVkX18uZg9+BD7q1klbD2CDJ/hUswekFEP6mT8="
  },
  {
    "num_cand": "U2FsdGVkX19qiRJ2T/sY/ieQyHemAUs1A3BtDxfrG4U=",
    "cpf": "U2FsdGVkX1/sF+8TqKJs+Xs8sndrUmYHNzFhsdV89mg="
  },
  {
    "num_cand": "U2FsdGVkX1/+hpH0jSauo87LmMtIGkQajtv8YwZOm8k=",
    "cpf": "U2FsdGVkX1+VJdXdUj7AoejXgVeSj4rhbcSJumBaqiw="
  },
  {
    "num_cand": "U2FsdGVkX197rYrCK5NCLMJrUTjvzLzl9K2Oor/xDCw=",
    "cpf": "U2FsdGVkX1+TGuQC6ULhfryqMQ1Z3W1i4c1Wyttrsds="
  },
  {
    "num_cand": "U2FsdGVkX19U6e4ukaIkvYO7iXL2/l0IVMHn6RHvZBw=",
    "cpf": "U2FsdGVkX18OnX1C5ZY+5GXyyVj0eaHubTO+7G30Khs="
  },
  {
    "num_cand": "U2FsdGVkX1932jDnzKSG8EX+jkQh9MnGAYmRS4NCkiQ=",
    "cpf": "U2FsdGVkX18AJzfOwIS5gInUJ6ijEqm1nEt6H8qYpu0="
  },
  {
    "num_cand": "U2FsdGVkX1/WDNlTbhJlQ0rp4/xCzGcaFJmCxHY9ntQ=",
    "cpf": "U2FsdGVkX18TAQg6uTTWBJ8LlMzBDv1SV2iyC/YmSu4="
  },
  {
    "num_cand": "U2FsdGVkX18fRyIf2G3h8ZzBHixAE3dFFT9b1mt8lRM=",
    "cpf": "U2FsdGVkX19gv2fC7oNXNYCbJ3Z8AUeW8bIr2d+73iU="
  },
  {
    "num_cand": "U2FsdGVkX1+GqELfns67+HbGjCqjtSFMApw4fBe28kA=",
    "cpf": "U2FsdGVkX19/DDvb67GtDDTDJUqNnkk4jRZIZ9mAuno="
  },
  {
    "num_cand": "U2FsdGVkX19fNFazXHENhEZgNaYIGuWwAcjBbLIQu24=",
    "cpf": "U2FsdGVkX1/EC4FlJLzUSmaSOjN09E9EWigKKX+Y6bQ="
  },
  {
    "num_cand": "U2FsdGVkX1/daQIxOQ/RCcTX0EAGDzzHmDA31USK6d4=",
    "cpf": "U2FsdGVkX1/imIGs4sbY0KCEMHabhlKSJdef5C4uY2w="
  },
  {
    "num_cand": "U2FsdGVkX19EWtNpmXkZ196dLVdpl9JolmyPo7f/1ZM=",
    "cpf": "U2FsdGVkX18Ez6MxiPju+s+npO43aRXb2W06FbX75zM="
  },
  {
    "num_cand": "U2FsdGVkX18svQnlNu/hz2zepxGgYjPfNA5ARrwyAd4=",
    "cpf": "U2FsdGVkX1/yts/QQwCmSj9Ek0MRUmOKm6bUv9JMWk8="
  },
  {
    "num_cand": "U2FsdGVkX19IosoW2kqYdNHckKQoPZ30PFGeWVRKzdw=",
    "cpf": "U2FsdGVkX19yUiKWsofxesROqQahOGk7XjxC1asOYrk="
  },
  {
    "num_cand": "U2FsdGVkX1+B7QDlnF+QODhmQEfJKR83w3e3l1Bip3k=",
    "cpf": "U2FsdGVkX18cF2dgfcuuxK7Fv1FItIILbGskI3U49/8="
  },
  {
    "num_cand": "U2FsdGVkX188gQu2n9G38m17Wgpb8VAqUqsH8ryF0HM=",
    "cpf": "U2FsdGVkX19HwYlZ+Jq4LcJ7dTZuwzsA68NS7lGU3Os="
  },
  {
    "num_cand": "U2FsdGVkX1+RW2nI6UzlYJcAITjzoSBToSmfWhackHY=",
    "cpf": "U2FsdGVkX19xKoeGZ67m1I/MyAHsHSmIyE/L+Heuwyg="
  },
  {
    "num_cand": "U2FsdGVkX19vYiUCs4RJzm8D24JTsokD97fah18Z1Dc=",
    "cpf": "U2FsdGVkX18ldDqLOZgfYgAg7hfw8PNB9HeQRs2u6Nk="
  },
  {
    "num_cand": "U2FsdGVkX1/148RQNgYYXH9J7FyF2D2BjNaeqvUjM0g=",
    "cpf": "U2FsdGVkX18qfzT8RWu5VQs63aNtFQswexLWr6v8ftY="
  },
  {
    "num_cand": "U2FsdGVkX1+p9Q+IuCMwWOIbf1XYP8oBDX44LBHAJTw=",
    "cpf": "U2FsdGVkX192XBo2xI83S0LHocRqOFkcXylD/DQWHU0="
  },
  {
    "num_cand": "U2FsdGVkX1/jJyYGY7bRGs6Aqnk2u9R+/zgweXBNW2U=",
    "cpf": "U2FsdGVkX1/cUQJR23B4UJYHmXhfhnpt8uJZkFmD6UI="
  },
  {
    "num_cand": "U2FsdGVkX1+kDVy3T2NxYXBN5PN0MdEB0IE3SR1/BPg=",
    "cpf": "U2FsdGVkX19sQoMgZ9OBmgRHhlAZNarRgl9DvnLm4nk="
  },
  {
    "num_cand": "U2FsdGVkX18BMLDrqJV8fAarcE99+gYb94x7v2nxQC4=",
    "cpf": "U2FsdGVkX1/67rC7cXvra4q7U9aI1ipNtHzVYNwu1D0="
  },
  {
    "num_cand": "U2FsdGVkX1/GzmFwbR4zNL497kg0iVMYtGLghJd8wqk=",
    "cpf": "U2FsdGVkX19K9yTGIr69WlI1kdl1YV9R4wOfV1v/cNg="
  },
  {
    "num_cand": "U2FsdGVkX193yl5sZXHHMlMMhSEss34iovi1BVOGkpY=",
    "cpf": "U2FsdGVkX19YaClu/TR/UW8gX64n0ZyZvRvd4F1ekLI="
  },
  {
    "num_cand": "U2FsdGVkX1+94YouzScAYXXlHyi1mdHmKZU5uw93+dE=",
    "cpf": "U2FsdGVkX18p6REUjCI7PS73g4ZQgONl3aTseHLJX54="
  },
  {
    "num_cand": "U2FsdGVkX1+GZrRnqNCMbMckS0FA4FvHKhMaMM5qHHE=",
    "cpf": "U2FsdGVkX18xMFzVBauVjwxGP2336Q9fI8F2v0qHa3g="
  },
  {
    "num_cand": "U2FsdGVkX18HXeRoU/QG67yCF2s1QLUW+6xk4+8jSKQ=",
    "cpf": "U2FsdGVkX195a16Oc58CaeXT5DGAhsCGbr577aSQnSs="
  },
  {
    "num_cand": "U2FsdGVkX186yXLcOJ1Rb847XfQAkjgf5g614meHAYU=",
    "cpf": "U2FsdGVkX18yASJT6H4ipSlkZdJ9+QVe/NHL4SwLShg="
  },
  {
    "num_cand": "U2FsdGVkX1++0cT4tgu6snfXNmUOHaOhoawfDMDL/wU=",
    "cpf": "U2FsdGVkX1/XtKIm4TomGMhx+edeBtV/PKltQOZVHWg="
  },
  {
    "num_cand": "U2FsdGVkX1/w0hnyuuarl3gDE7pnUuev3RS/GYsizwY=",
    "cpf": "U2FsdGVkX18ujcmhnbjuxwu65awZCDXuHa084Vbm3TA="
  },
  {
    "num_cand": "U2FsdGVkX1+BKmaFF3pDnxKtQEFIN2fZ8zau8CXQvbU=",
    "cpf": "U2FsdGVkX1/4Z+UyxK4ZBvhibe1nzYXhVAs7JPeI7JM="
  },
  {
    "num_cand": "U2FsdGVkX1/1kBLauavZJVT6q+5oHq6+SyqeG+fnWPw=",
    "cpf": "U2FsdGVkX1/8re99lYeqKWdJwWYpPxR8KJJ9t3oT8sA="
  },
  {
    "num_cand": "U2FsdGVkX1+jVzXbgCn5+43iigVlVEIcZ+tlH54y0v4=",
    "cpf": "U2FsdGVkX1+xfkJGKlt8Mddq907xY1H867yFwkeOXgE="
  },
  {
    "num_cand": "U2FsdGVkX1/btyhVY2YWny4aLSmWpgBT2mHCTM5o/YM=",
    "cpf": "U2FsdGVkX18zirqInW+aWVKNCrCdzXlWCIEnBSWxepY="
  },
  {
    "num_cand": "U2FsdGVkX1/P0uMeUQYIn0iJI9UCWJyGtlW7Ldub2gU=",
    "cpf": "U2FsdGVkX19OnhBgL8Pz1ScSckOIjj/5dKVDEs9Z3iU="
  },
  {
    "num_cand": "U2FsdGVkX1+AJwrlwIoZzW1ItLTOL9gmV8qokqvVntg=",
    "cpf": "U2FsdGVkX18NUmXSs4/L5rrieDMUWCPs1ozqXn2lHh8="
  },
  {
    "num_cand": "U2FsdGVkX18LUaovomKLa8fl05UbQPLcaBFmngCh//0=",
    "cpf": "U2FsdGVkX19M/0ijhHsuXJOIskyI2VwBN48j9yO5QPU="
  },
  {
    "num_cand": "U2FsdGVkX19Q/2FKCIc/i3WB4JhgRsIlyBWH6FF9oo0=",
    "cpf": "U2FsdGVkX19X8OgHtZY0TG8Ww24uZrk2kL54x7P5Gh0="
  },
  {
    "num_cand": "U2FsdGVkX1/ZHod58+8U34w/zQkYeJMAU4EXPWvcQb4=",
    "cpf": "U2FsdGVkX1/hXRUwmp+/SaC8pvTTsroSQUOgnC7rxl8="
  },
  {
    "num_cand": "U2FsdGVkX1/XcjUAWMKjEIBy9oQg5fznvgKy4hs0H7w=",
    "cpf": "U2FsdGVkX194ruJ1mS61AOyhhiq5+LOv0xJ9jaxWhJg="
  },
  {
    "num_cand": "U2FsdGVkX1//jIQFM1dlEtAI0T0tdcSpxoBZ2aTeZek=",
    "cpf": "U2FsdGVkX18t+6BiJM51p/alzT+IbxJAwSMdvraDvgo="
  },
  {
    "num_cand": "U2FsdGVkX1/G5UmmezggFUPF4rsLA/66s3LJa3irUw8=",
    "cpf": "U2FsdGVkX1/FcKm0nejhtK2OkrGSC60+1F5unwDPgzc="
  },
  {
    "num_cand": "U2FsdGVkX1/lP24inOKhgPUffPSxzl77G2WCfbBJP8I=",
    "cpf": "U2FsdGVkX1/qjd1emxyBdgR/1tJXDSSAge8+fXPp3NE="
  },
  {
    "num_cand": "U2FsdGVkX19VypFwjjtMjRlXkB3LJq+lRDzCp5WNZT0=",
    "cpf": "U2FsdGVkX19yQ/1gwxP4n24lNw3XVtU063+ub4e387I="
  },
  {
    "num_cand": "U2FsdGVkX192cK6E2nYud9t9jDpi8nLmSff8dwby1Vk=",
    "cpf": "U2FsdGVkX18ItgUfyMEa5zgSzTMS6/LiU0paEJhR2l8="
  },
  {
    "num_cand": "U2FsdGVkX19mfLxWbyk2Bqvvnab/XP8lSESJsGtoBNI=",
    "cpf": "U2FsdGVkX1+H7KpsQWQ+KBlOkGSEFdW7O6jc4hCkc+o="
  },
  {
    "num_cand": "U2FsdGVkX1+b09yDZ1+cu1VQ5+twKYs05VasXLzrQiY=",
    "cpf": "U2FsdGVkX18XgfUHBB/s3xbPUWpOSap6k92D3icmA4w="
  },
  {
    "num_cand": "U2FsdGVkX1+oLlnsX89qhGUae72md/Y5Cxgq/eQBPy0=",
    "cpf": "U2FsdGVkX1/Rmt8a9ZJAzNSWVJC9Og/Hn+keGvCxddw="
  },
  {
    "num_cand": "U2FsdGVkX1/9prQZ4yH8Gq+XQEhvpYkJjQ0Xyl3rFIE=",
    "cpf": "U2FsdGVkX19wWclZLr6FdrCpAzhEnjFz3dnttfHLSbA="
  },
  {
    "num_cand": "U2FsdGVkX1+jNYYi5lWqY4vPQL5jHYJdzmsrqdlyhv0=",
    "cpf": "U2FsdGVkX1+mXZVoDIHgBR3mi3EKwJSxAB35stciUA4="
  },
  {
    "num_cand": "U2FsdGVkX1+RWxLcK5R9d3llNmP1v5JgQuYtGV8y7l4=",
    "cpf": "U2FsdGVkX19RhvP4QMrDBWQrxPBn+/1MNyxjkG4M6mk="
  },
  {
    "num_cand": "U2FsdGVkX18ltp3XzuFwraTswQykS+k9JUoy6n6xkrM=",
    "cpf": "U2FsdGVkX18+hIMhxICII+1RqT3RZ1JS2YRPzj3QB2g="
  },
  {
    "num_cand": "U2FsdGVkX19+hKBGor+iN9/+slAT/o1YdtvtcUA2ibc=",
    "cpf": "U2FsdGVkX18LdofMgBPjCfACcp6TI6E4FHxtgah4lCc="
  },
  {
    "num_cand": "U2FsdGVkX1890ZFT8NzfMXHUMkgrv9VSnNoDi3+OOkA=",
    "cpf": "U2FsdGVkX19GVk+rZs3UED0cYlmmvHxWvjQtthdF8s0="
  },
  {
    "num_cand": "U2FsdGVkX187QXNcoDmqYxQVbHDZqZRI8WQE37/C15g=",
    "cpf": "U2FsdGVkX19TEOu90ZYrpcmxrkxC4ctOmxTWnyckeN0="
  },
  {
    "num_cand": "U2FsdGVkX1/hpa8/cD8mgsYIB9eCFOCYafB+CVq8Ruk=",
    "cpf": "U2FsdGVkX18SnfR5rUUM9ZTywHcmPrEF4gH+swUcSWk="
  },
  {
    "num_cand": "U2FsdGVkX184PAe07hCS8N9zn6bXIxSSLslK3sU8E0Q=",
    "cpf": "U2FsdGVkX1/hY9kJ8Dssrn6gl0yRz+NXElbj3o5l72M="
  },
  {
    "num_cand": "U2FsdGVkX1/Oox2WQYObPIguXwyjW6YDX/jSH+GUU+g=",
    "cpf": "U2FsdGVkX189SMQn3uvP2ITGl5BmGwKsSoeWWBre7FA="
  },
  {
    "num_cand": "U2FsdGVkX18NfRP7PXEe+62XvJ5hxJ7qkdDo3R6uHSs=",
    "cpf": "U2FsdGVkX18S//CF4spT4xHTEB2AlakS850/ANtZXOQ="
  },
  {
    "num_cand": "U2FsdGVkX1955KO2q3CICjnhZXSatEwiQER9aQL1dz8=",
    "cpf": "U2FsdGVkX1+oMskJl1fade8++t1e8rX2OkH2kzbJc5s="
  },
  {
    "num_cand": "U2FsdGVkX1+YwUV6Dbfe2RylD2CNNiZNMgevo6p0upA=",
    "cpf": "U2FsdGVkX19reHKVm9FWiyPS5l/Uw0hQ+keC556fGL8="
  },
  {
    "num_cand": "U2FsdGVkX190LCO39HIKkblOBuEp/SAvJ71g4YJdRuM=",
    "cpf": "U2FsdGVkX1/w7RR++ANMT5Kb6+m6wJqcZ+Nr/QyQ98M="
  },
  {
    "num_cand": "U2FsdGVkX1/I76LhRu9PO/t+M3xDljc90DtWuESqiNM=",
    "cpf": "U2FsdGVkX1/4g3QIUUi9DZhZL5erBTaZCBHD6dPapIY="
  },
  {
    "num_cand": "U2FsdGVkX1/rvkwfg8tQTH9cXoAYef5uUF6m8iVjJQE=",
    "cpf": "U2FsdGVkX18LNZyJLWGAI4z4iKr4WwICQ9GkDy3POzM="
  },
  {
    "num_cand": "U2FsdGVkX1/3wR9ljYVBoJao28Yn8CHHmpF33ZRFKRM=",
    "cpf": "U2FsdGVkX19hjsCn5SEjdCwz/oaU5kVpMWBjNdZ8LC8="
  },
  {
    "num_cand": "U2FsdGVkX1+rKtkaqWMZJPp3/1ZKfK/Sv30aWXaZWY4=",
    "cpf": "U2FsdGVkX18DwLM1OeALqankq8xvbA/90EKyrB30qEA="
  },
  {
    "num_cand": "U2FsdGVkX1/im8tY6WoWyVzpUtJW8qmTGJQc6b21cQ4=",
    "cpf": "U2FsdGVkX1/yqPpOnCFmv/ZZOVerPmpQSAMRjbHn51s="
  },
  {
    "num_cand": "U2FsdGVkX1/70wE3ar03Uk3smcuFJF/03qlM4rqXBz8=",
    "cpf": "U2FsdGVkX19XwynDITnMeHWe/7fI1SALzF59GfXs8MY="
  },
  {
    "num_cand": "U2FsdGVkX1/iTpLHJm2s1i2IUZqBwdBGN84SzeIkuiU=",
    "cpf": "U2FsdGVkX19XbniS2A9meFPFyVW4AYn6x/yvMP7c48U="
  },
  {
    "num_cand": "U2FsdGVkX185r8MQiuGNpDLid4h1BuLd+Y8ZRkdNBXE=",
    "cpf": "U2FsdGVkX18K0ISL3xtrQIQTX9PSioCAc95LE5ei09o="
  },
  {
    "num_cand": "U2FsdGVkX18awbARPdpRceE7RKy0o4kTmoDN79fB6dE=",
    "cpf": "U2FsdGVkX188lunfbe6WRN5SOGvjFOQf8symKBJ/NQ4="
  },
  {
    "num_cand": "U2FsdGVkX19QkGOVd2AZzsTmp2xeo7KCLqASAXPgv5w=",
    "cpf": "U2FsdGVkX18gcEaA/Ki/S1IFL6uIyJzjBBlqNcqcK3g="
  },
  {
    "num_cand": "U2FsdGVkX18Ryysvw3RAijxGaqoRjsUtm0/vUDeFIFQ=",
    "cpf": "U2FsdGVkX19rAjSBwpxKa8P56YW/K2XZrl96fJ3IsF4="
  },
  {
    "num_cand": "U2FsdGVkX1+mh1Smd8gOl1J0+xJ22iUaj5dRNZiL5wU=",
    "cpf": "U2FsdGVkX1+d1W/lwn/8ZAbfmAZ1DEsVc3D8pN//SuI="
  },
  {
    "num_cand": "U2FsdGVkX1/b0i7J52puBE901UADSDaiVdQPPaJ6U7A=",
    "cpf": "U2FsdGVkX1/hBusrsNw3lS0O+mYDdu4s0x+D+KWzmqE="
  },
  {
    "num_cand": "U2FsdGVkX1/v46BmJoR0KDa6zdegPSw8HEegJ/XMxmM=",
    "cpf": "U2FsdGVkX1+QKPzQ60G12D6w1p/dS3XEDMx7kZNaPlw="
  },
  {
    "num_cand": "U2FsdGVkX1/ve0+7sPDOqgj3IUIt8LjuL24QkwBikVo=",
    "cpf": "U2FsdGVkX19GXQ891txGQYEP1oz/YbIa+WRsJUB1zpE="
  },
  {
    "num_cand": "U2FsdGVkX1/eg6btx4M/7JAy4AhKJdvc0CrJWcEdPpk=",
    "cpf": "U2FsdGVkX1+GV3X1pFV1A9zhi7W2syBzThKbR8LJ1GM="
  },
  {
    "num_cand": "U2FsdGVkX19BCvQux+/nDYztW6fiKmyzx9pos8AQ/xk=",
    "cpf": "U2FsdGVkX18RlvkCp1iqXuc79ne5s5PkCuRI2dUjpXE="
  },
  {
    "num_cand": "U2FsdGVkX18GV7nMmyNR4sZSQ71VqOKQomsj/v5JD5w=",
    "cpf": "U2FsdGVkX19Swy7jnvQT2dhMYAz/cNGnmKLPrc+AvXQ="
  },
  {
    "num_cand": "U2FsdGVkX1+uqU8ic5vzFuvgvNVAEeMNw4BPv6LpMbg=",
    "cpf": "U2FsdGVkX1+XL1jJ2g+YZ1qyAndiSKB2WRl5RENbkEA="
  },
  {
    "num_cand": "U2FsdGVkX1//v04ePkFaj86Tl++p7CItELVaz8A0D28=",
    "cpf": "U2FsdGVkX18hltffHYXjxAC7HXm2CqG6+Ewj76dDGlE="
  },
  {
    "num_cand": "U2FsdGVkX18utEvETGHBcueCq4LBPXLfE67KNsKlV4I=",
    "cpf": "U2FsdGVkX19IrawSPFU17LVa8BXbf8KiVTX1mjtvKOg="
  },
  {
    "num_cand": "U2FsdGVkX197cu2xIQRB35Av6toIKo+OTzVdE0VGU9k=",
    "cpf": "U2FsdGVkX1+v5O4qYABOHY/j8hwkg8/vJ/x6uozC6nY="
  },
  {
    "num_cand": "U2FsdGVkX19NN28bfOy4J/txAdOVwNtZAn1XEAr+ASk=",
    "cpf": "U2FsdGVkX18PtmnFo3S9aEA6fsQdgrcokJANZ98lYnA="
  },
  {
    "num_cand": "U2FsdGVkX1/gmeT5URXVhmB7QkWQmnyw4gqtwClhWxc=",
    "cpf": "U2FsdGVkX1/dLHWZvRMzr9KOlJF2FHbeQT7hXAztK0A="
  },
  {
    "num_cand": "U2FsdGVkX1/6HZXErxHpWMHC99Pd7UDa47IYJS8Uya4=",
    "cpf": "U2FsdGVkX18XD7TW9/yQhz5ptVSkrkMXd1Zpk+L0DMQ="
  },
  {
    "num_cand": "U2FsdGVkX198L2XkaSY/BnptTW99L6aH3ayCDvvCA6Q=",
    "cpf": "U2FsdGVkX1978l/pKimFkGnVhUKa15xYkhEdezjZZZg="
  },
  {
    "num_cand": "U2FsdGVkX19zB2WcuaZqyo5LlmKiHG79bolodHEdcZw=",
    "cpf": "U2FsdGVkX1+/vN/uw2m90iMUMFifzzcjqjJiwcPt/R4="
  },
  {
    "num_cand": "U2FsdGVkX18MchNgjCz/vNU0cCZxVB/6gKvvNVxuODs=",
    "cpf": "U2FsdGVkX1/UsxOLVKZfIN0J3FMOzWuZPAgVY9B9YHI="
  }
]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
            let num_cand_decripted = decrypt(login.num_cand);
            let cpf_decripted = decrypt(login.cpf);

            // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
             let nome_arquivo = (gera_file_name(cpf_decripted,num_cand_decripted))


            // alert(`Logou`);
              let url = (`https://fs.ibfc.org.br/arquivos/2204/2204_rec-ped_inse/${nome_arquivo}`)
            return window.location.replace(url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
